// extracted by mini-css-extract-plugin
export default {"input":"SegmentedMenuItem_input__xO5L7","selectedText":"SegmentedMenuItem_selectedText__4kGNN","tabItemContainer":"SegmentedMenuItem_tabItemContainer__zyp1T"};